(ns app.front.view.admin.migration.move-committees-to-domain
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/move-committees-to-domain-group
    :title     "Move committees from authority groups to domain groups"
    :help-text (str "This migration moves all committees from authority groups to their parent domain groups. "
                    "Run this migration right after enabling the :feature-flag.id/domain-level-meetings flag. "
                    "Committees will be moved from authority groups to their respective parent domain groups.")}
   match])

(def route
  {:name        :view/admin.migration.move-committees-to-domain
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/move-committees-to-domain-group]))}]})
